import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState, useRef } from "react";
import {  Link, useNavigate } from "react-router-dom";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import * as XLSX from 'xlsx';

import "react-calendar/dist/Calendar.css";
import {
  GetFeeCollectionReport,
} from "../../../api/ReportsServices";
import { getBatchList } from "../../../api/BatchService";
import { formatDate, SweetAlertShow } from "../../master/Master";
import { getSessions } from "../../../api/SessionsService";
import { BankList } from "../../../api/BankService";
import ReportHeader from "./ReportHeader";
import { setPrintContent } from "../../../PrintStore";
import { StaffList } from "../../../api/Staff";

export default function FeeReport() {
  const hasAccess = usePrivateLink();
  const [page, setPage] = useState(1);
  const [Data, setData] = useState(null);
  const [total, setTotal] = useState(0);
  const [batches, setBatches] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [name, setName] = useState("");
  const [batchId, setBatchID] = useState("");
  const [staffId, setStaffId] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedSession, setSelectedSessions] = useState('');
  const [sessions, setSessions] = useState([]);
  const [error, setError] = useState('');
  const [transition, setTransition] = useState([]);
  const [type, setType] = useState('');
  const [banks, setBanks] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState('');
  const [status, setStatus] = useState(1);
  const navigate = useNavigate();


  const getBusinessBanks = async () => {
    setLoading(true)
    try {
      const response = await BankList();
      if (response?.data?.status) {
        setBanks(response?.data?.data)
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })

        SweetAlertShow('info','Warning',response?.data?.message)
      }

    } catch (error) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message  || 'something went wrong'
      // })

      SweetAlertShow('error','Error',error?.response?.data?.message  ?? error?.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getBusinessBanks();
  }, []);


  const getDefaultDates = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date) => {
      if (!(date instanceof Date)) date = new Date(date); // ensure it's a Date
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    return {
      from: formatDate(firstDayOfMonth),
      to: formatDate(today),
    };
  };

  const { from: defaultFrom, to: defaultTo } = getDefaultDates();

  const [from, setFrom] = useState(defaultFrom);
  const [to, setTo] = useState(defaultTo);

  const getSession = async () => {
    setLoading(true)
    try {
      const response = await getSessions();
      if (response?.data?.status) {

        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getSession();
  }, []);



  const handleExportAll = async () => {
    try {
      let addUrl = `&page=${page}&session_id=${selectedSession}`;
      if (from) addUrl += `&start_date=${from}`;
      if (to) addUrl += `&end_date=${to}`;
      if (batchId) addUrl += `&batch_id=${batchId}`;
      if (staffId) addUrl += `&staff_id=${staffId}`;
      if (name) addUrl += `&search=${name}`;
      if (type) addUrl += `&type=${type}`
      if (selectedAccount) addUrl += `&bank_id=${selectedAccount}`
      setLoading(true);
      let allData = [];

      // First fetch page 1 to get last_page info
      const firstResponse = await GetFeeCollectionReport(`${addUrl}&page=1`);
      const lastPage = firstResponse?.data?.data?.last_page || 1;

      // Loop through all pages
      for (let page = 1; page <= lastPage; page++) {
        const response = await GetFeeCollectionReport(`${addUrl}page=${page}`);
        const records = response?.data?.data?.data || [];
        allData.push(...records);
      }

      if (allData.length === 0) {
        alert("No data to export!");
        return;
      }

      // Flatten and safe mapping
      const formattedData = allData.map(item => ({
        "Student Name": item.student?.name || "",
        "registration No": item.student?.registration_no || "",
        // "registration No": item.student?.registration_no || "",
        "Mobile Number": item.student?.phone || "",
        "Batch Name": item.batch?.title || "",
        "Amount": item.amount || 0,
        "Bank": item?.bank && item.bank.account_no
          ? item.bank.owner_name || "N/A"
          : "N/A",

        "Payment Method": item.payment_method || "",
        "Fee Date": item.fee_date || "",
        "Next Payment Date": item.next_payment_date || "",
        "Description": item.description || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Fee Collection");
      XLSX.writeFile(workbook, "FeeCollection.xlsx");

      alert(`Exported ${allData.length} records successfully!`);
    } catch (error) {
      console.error(error);
      alert(`Error in exporting: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const loadOnce = useRef(false);

  const fetchData = async () => {
    setLoading(true);
    let addUrl = `&page=${page}&session_id=${selectedSession}`;
    if (from) addUrl += `&start_date=${from}`;
    if (to) addUrl += `&end_date=${to}`;
    if (batchId) addUrl += `&batch_id=${batchId}`;
    if (staffId) addUrl += `&staff_id=${staffId}`;
    if (name) addUrl += `&search=${name}`;
    if (status || status=="0") addUrl += `&status=${status}`
    if (selectedAccount) addUrl += `&bank_id=${selectedAccount}`
    try {
      const response = await GetFeeCollectionReport(addUrl);
      setData(response?.data?.data);
      setTransition(response.data?.data || []);
      setTotal(response?.data?.total_sum);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };



  const getBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`
    setLoading(true);
    try {
      let response = await getBatchList(addUrl);

      setBatches(response?.data?.batches);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStaffs = async () => {
    setLoading(true);
    try {
      let response = await StaffList();
      setStaffs(response?.data?.batches);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStaffs();

  }, []);

  useEffect(() => {
    getBatches();
  }, [selectedSession])




  useEffect(() => {
    fetchData();
  }, [page, from, to, batchId, staffId, name, selectedSession, status, selectedAccount]);
const handlePrint = () => {
    const printTable = (
      <div className="table-responsive">
        <table className="table table-hover">
          <thead className={`table-primary ${status == '3' ? 'table-danger' : 'table-primary'}`}>
            <caption className="text-center fw-bold fs-5 mb-2 w-100">
              Fee Collection List
            </caption>
            <tr className="text-center">
              <th>#</th>
              <th>Student Name</th>
              <th>Mobile</th>
              <th>Batch</th>
              <th>Payment Mode / Trans_id</th>
              <th>Remark</th>
              <th>Date</th>
              <th>Bank</th>
              <th>Amount</th>

            </tr>
          </thead>
          <tbody className="text-capitalize">
            {Data?.data?.map((data, i) => (
              <tr>
                <td>{i + 1}</td>
                <td>
                  {data?.student?.name}(
                  {data?.student?.registration_no})
                </td>
                <td>{data?.student?.phone}</td>
                <td>{data?.batch?.title}</td>
                <td>
                  {data?.payment_method} ({data?.transaction_no})
                </td>
                <td>{data?.description}</td>
                <td>{formatDate(data?.fee_date)}</td>
                <td>{data?.bank ? `${data.bank.account_no} (${data.bank.owner_name})` : "N/A"}</td>

                <td>₹{data?.amount}</td>


              </tr>
            ))}
          </tbody>
        </table>

        <nav aria-label="Page navigation" className="mt-10">
          <p>
            Showing {Data?.from} to {Data?.to} of{" "}
            {Data?.total} entries
          </p>
          <ul className="pagination pagination-sm">
            {Data?.links?.map((btn, i) => (
              <li
                className={`page-item  ${btn?.active && "active"
                  }  ${btn?.url ? "" : "disabled"} `}
              >
                <button
                  className="page-link waves-effect"
                  onClick={() => {
                    if (Data?.links?.length === i + 1) {
                      btn?.url &&
                        setPage(Data?.current_page + 1);
                    } else if (i === 0) {
                      btn?.url &&
                        setPage(Data?.current_page - 1);
                    } else {
                      setPage(btn.label);
                    }
                  }}
                >
                  {Data?.links?.length == i + 1 ? (
                    <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                  ) : i == 0 ? (
                    <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                  ) : (
                    btn?.label
                  )}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    );

    setPrintContent(printTable);
    navigate("/print");
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <>
              {/* Content */}
              <div className="container-fluid mt-2">
                <div className="row">

                  <div className="d-flex gap-2">
                    <div className="col-md-3">
                      <ReportHeader data={'Report Portal'} />
                    </div>
                    <div className="col-md-9">

                      <div className="card mb-4 p-3">
                        <div className="d-flex mb-2">
                          <h5 className="mb-3 text-primary">Fee Report</h5>
                          <div className="ms-auto">
                            <div className="form-floating form-floating-outline">
                              <select className="form-select" name="session" value={selectedSession} onChange={(e) => setSelectedSessions(e.target.value)}>
                                {/* <option value="">Select Session</option> */}
                                {sessions?.map((session) => (
                                  <option
                                    key={session?.id}
                                    value={session?.id}
                                  >
                                    {session?.session}:{session?.status == '1' ? 'Active' : ' Inactive'}
                                    {/* Show "2023-24" */}
                                  </option>
                                ))}
                              </select>

                              <label >
                                Filter Session
                              </label>
                            </div>
                          </div>

                        </div>
                        <div className="row g-3 align-items-center">
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-6">
                              <input
                                type="date"
                                className="form-control"
                                name="start"
                                value={from}
                                onChange={(e) => setFrom(e.target.value)}
                              />
                              <label htmlFor="">From Date</label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-6">
                              <input
                                type="date"
                                className="form-control"
                                name="end"
                                value={to}
                                onChange={(e) => setTo(e.target.value)}
                              />
                              <label htmlFor="">To Date</label>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-6">
                              <select
                                name="batch_id"
                                className="form-select"
                                value={batchId}
                                onChange={(e) => setBatchID(e.target.value)}
                              >
                                <option value="">All Batch</option>
                                {batches?.map((batch, i) => {
                                  const courseTitle = batch?.course?.title || "";
                                  const shortCourseTitle =
                                    courseTitle.length > 20
                                      ? courseTitle.substring(0, 20) + "..."
                                      : courseTitle;

                                  return (
                                    <option key={i} value={batch?.id}>
                                      {`${batch?.title} (${shortCourseTitle})`}
                                    </option>
                                  );
                                })}
                              </select>
                              <label htmlFor="">Select Batch</label>
                            </div>
                          </div>


                          {/* <div className="col-md-3">
                          <div className="form-floating form-floating-outline mb-6">
                            <select
                              name="staff_id"
                              id=""
                              className="form-select"
                              value={staffId}
                              onChange={(e) => setStaffId(e.target.value)}
                            >
                              
                              {staffs?.map((staff, i) => (
                                <option key={i} value={staff?.id}>
                                  {staff?.name}
                                </option>
                              ))}
                            </select>
                            <label htmlFor="">Select Staff</label>
                          </div>
                        </div> */}

                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-6">
                              <select
                                name="account_no"
                                id=""
                                className="form-select"
                                value={selectedAccount}
                                onChange={(e) => setSelectedAccount(e.target.value)}
                              >
                                <option>Select Banks</option>
                                {banks?.map((item, index) => (
                                  <option key={item?.id} value={item?.id}>{item?.account_no}:({item?.owner_name})</option>
                                ))}
                              </select>
                              <label htmlFor="">Select Account</label>
                            </div>
                          </div>


                          <div className="col-md-3">
                          </div>
                        </div>
                      </div>
                      <div className="card p-3">
                        <div className="d-flex justify-content-between ">
                          <div className="manoj">

                            <p className="m-0">Total : {total}</p>
                          </div>
                          <div className="d-flex justify-content-end">
                            {hasAccess('/fees/report/export') && (
                              <button
                                className="btn btn-success btn-sm"
                                onClick={handleExportAll}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Export Excel"
                              >
                                <i className="bi bi-cloud-arrow-down ri-20px"></i>
                              </button>
                            )}
                            <button
                              className={`btn btn-sm ${status == '1' ? 'btn-primary' : 'btn-outline-primary'} ms-2`}
                              onClick={(e) => {
                                setStatus(1)
                              }}
                              title="collection"
                            >
                              Collection
                            </button>
                            <button
                              className={`btn btn-sm ${status == '0' ? 'btn-primary' : 'btn-outline-primary'} ms-2`}
                              onClick={(e) => {
                                setStatus(0)
                              }}
                              title="collection"
                            >
                              Pending
                            </button>
                            {hasAccess("/fees/report/deleted") && (

                              <button
                                className={`btn btn-sm ${status == '3' ? 'btn-danger' : 'btn-outline-danger'} ms-2`}
                                onClick={(e) => {
                                  setStatus(3)
                                }}
                                title="deleted collection"
                              >
                                Delete
                              </button>
                            )}
                            {hasAccess("/fees/report/print") && (
                              <button className="btn btn-primary ms-2" onClick={handlePrint}>
                                Print
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead className={`table-primary ${status == '3' ? 'table-danger' : 'table-primary'}`}>
                              <tr className="text-center">
                                <th>#</th>
                                <th>Student Name</th>
                                <th>Mobile</th>
                                <th>Batch</th>
                                <th>Payment Mode / Trans_id</th>
                                <th>Remark</th>
                                <th>Date</th>
                                <th>Bank</th>
                                <th>Amount</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody className="text-capitalize">
                              {Data?.data?.map((data, i) => (
                                <tr>
                                  <td>{i + 1}</td>
                                  <td>
                                    {data?.student?.name}(
                                    {data?.student?.registration_no})
                                  </td>
                                  <td>{data?.student?.phone}</td>
                                  <td>{data?.batch?.title}</td>
                                  <td>
                                    {data?.payment_method} ({data?.transaction_no})
                                  </td>
                                  <td>{data?.description}</td>
                                  <td>{formatDate(data?.fee_date)}</td>
                                  <td>{data?.bank ? `${data.bank.account_no} (${data.bank.owner_name})` : "N/A"}</td>

                                  <td>₹{data?.amount}</td>
                                  <td>
                                    {/* When status == '1' → show Print + Delete */}
                                    {status == '1' && hasAccess("/student/fees/receipt") && (
                                      <>
                                        <Link
                                          to={`/student/fees/receipt?id=${data?.id}`}
                                          className="btn btn-sm btn-outline-primary"
                                        >
                                          Print
                                        </Link>
                                      </>
                                    )}

                                    {/* When status == '3' → show only Delete */}
                                    {status == '3' && (
                                      <button
                                        className="btn btn-sm btn-danger"
                                        title="Delete collection"
                                        disabled={status == '3'}
                                      >
                                        Deleted
                                      </button>
                                    )}
                                  </td>

                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <nav aria-label="Page navigation" className="mt-10">
                            <p>
                              Showing {Data?.from} to {Data?.to} of{" "}
                              {Data?.total} entries
                            </p>
                            <ul className="pagination pagination-sm">
                              {Data?.links?.map((btn, i) => (
                                <li
                                  className={`page-item  ${btn?.active && "active"
                                    }  ${btn?.url ? "" : "disabled"} `}
                                >
                                  <button
                                    className="page-link waves-effect"
                                    onClick={() => {
                                      if (Data?.links?.length === i + 1) {
                                        btn?.url &&
                                          setPage(Data?.current_page + 1);
                                      } else if (i === 0) {
                                        btn?.url &&
                                          setPage(Data?.current_page - 1);
                                      } else {
                                        setPage(btn.label);
                                      }
                                    }}
                                  >
                                    {Data?.links?.length == i + 1 ? (
                                      <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                    ) : i == 0 ? (
                                      <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                    ) : (
                                      btn?.label
                                    )}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>




              </div>
            </>


          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
